import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gift, ArrowRight } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export const BrewekQuickCard = () => {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/admin/gacha/settings").then((r) => setS(r.data)).catch(() => setS(null));
  }, []);
  if (!s) return null;
  const toggle = (v) => {
    const next = { ...s, enabled: v };
    setS(next);
    api.put("/admin/gacha/settings", next).then(() => toast.success(v ? "Event brewek dinyalakan" : "Event brewek dimatikan")).catch((e) => { setS(s); toast.error(formatApiError(e.response?.data?.detail)); });
  };
  return (
    <section data-testid="admin-brewek-quick" className="mt-8 flex flex-col gap-4 rounded-3xl bg-surface p-6 ring-1 ring-volt/30 sm:flex-row sm:items-center sm:justify-between md:p-8">
      <div className="flex items-center gap-4">
        <Gift className="h-8 w-8 shrink-0 text-volt" />
        <div>
          <p className="font-display text-xl text-paper">Event Brewek</p>
          <p className="text-sm text-zinc-400">{s.enabled ? "Sedang AKTIF — tampil di menu website" : "Mati — halaman tersembunyi"}{s.test_mode ? " · Mode uji coba aktif" : ""}</p>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <label className="flex items-center gap-2 text-sm text-zinc-200">
          <Switch data-testid="admin-brewek-quick-toggle" checked={s.enabled} onCheckedChange={toggle} className="data-[state=checked]:bg-volt data-[state=unchecked]:!bg-zinc-700" />
          {s.enabled ? "On" : "Off"}
        </label>
        <a href="/tigasatu/brewek" data-testid="admin-brewek-quick-link" className="flex items-center gap-1.5 rounded-full border border-white/15 px-4 py-2 text-sm text-zinc-200 hover:border-volt">Atur hadiah & kode <ArrowRight className="h-4 w-4" /></a>
      </div>
    </section>
  );
};
